import React, { useEffect, useState } from "react";
import "./Header.css";
import logo from "../assets/logo.png"; 
import { Link } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [productOpen, setProductOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => {
    setMenuOpen(false);
    setProductOpen(false);
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <Link
  to="/"
  onClick={(e) => {
    e.preventDefault();
    closeMenu();
    window.location.href = "/";
  }}
>
  <img src={logo} className="logo-img" alt="Flowtech Logo" />
</Link>

        {/* MOBILE ICON: Transforms from 3 bars to an X */}
        <div className={`nav-toggle ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <Link className="nav-item" to="/" onClick={closeMenu}>HOME</Link>
          <Link className="nav-item" to="/about" onClick={closeMenu}>ABOUT</Link>

          <div className={`nav-item dropdown ${productOpen ? "open" : ""}`} 
               onClick={() => setProductOpen(!productOpen)}>
            PRODUCTS
            <div className="dropdown-box">
              <Link to="/products/transformer-oil-pumps" onClick={closeMenu}>Transformer Oil Pumps</Link>
              <Link to="/products/canned-motor-pumps" onClick={closeMenu}>Sealless Canned Motor Pumps</Link>
              <Link to="/products/marine-pumps" onClick={closeMenu}>Marine Centrifugal Pumps</Link>
              <Link to="/products/monoblock-pumps" onClick={closeMenu}>Self-Priming Monoblock Pumps</Link>
              <Link to="/products/process-pumps" onClick={closeMenu}>Centrifugal Process Pumps</Link>
            </div>
          </div>

          <Link className="nav-item" to="/services" onClick={closeMenu}>SERVICES</Link>
          <Link className="nav-item" to="/clients" onClick={closeMenu}>CLIENTS</Link>
          <Link className="nav-item" to="/gallery" onClick={closeMenu}>GALLERY</Link>
          <Link className="nav-item" to="/downloads" onClick={closeMenu}>DOWNLOADS</Link>
          <Link className="nav-item" to="/quality-certificate" onClick={closeMenu}>QUALITY & CERTIFICATE</Link>
          <Link className="nav-item" to="/contact" onClick={closeMenu}>CONTACT</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;